<template>
  <div id="mask" @click="onshut">
    <div class="messagebox" @click="hideindu($event)" :style="'width:'+width+';height:'+height">
      <div class="title">
        <h4>添加组织负责人</h4>
        <div @click="onshut"></div>
      </div>
      <div class="content">
        <div class="tree">
          <div :class="orgId == form.orgId ? 'c_name c_checked' :'c_name'" @click="getAll" style="cursor: pointer;">
            {{label}}
          </div>
          <div class="c_tree">
            <el-tree @node-click="filterNode" :expand-on-click-node="false" :data="children" :props="defaultProps" node-key="label" ref="trees"></el-tree>
          </div>
        </div>
        <div class="ctable">
          <div class="name">
            {{label}}
          </div>
          <div class="search">
            <span>姓名</span>
            <el-input placeholder="请输入关键字" style="width:190px" v-model="form.name"></el-input>
            <button class="btn subbtn" type="button" @click="loadData">搜索</button>
          </div>
          <!--<div class="checkedall">-->
            <!--<el-checkbox :indeterminate="indeterminate" v-model="checkAll" @change="oncheckAll">全选当前部门员工</el-checkbox>-->
          <!--</div>-->
          <div class="table" ref='tablediv'>
            <el-table :data="list" style="width: 100%" ref='table' :header-cell-style="{background:'#f8fafb',color: '#303140'}" @select="select" @select-all="selectAll">
              <el-table-column type="selection" min-width="55"></el-table-column>
              <el-table-column prop="name" label="姓名" min-width="25" align="left"></el-table-column>
              <el-table-column prop="wechat" label="微信公众号" min-width="40" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.wechat == '未关联'" class="block redbg">未关联</span>
                  <span v-if="scope.row.wechat == '已关联'" class="block greenbg">已关联</span>
                </template>
              </el-table-column>
              <el-table-column prop="department" label="部门" min-width="40" align="left"></el-table-column>
              <el-table-column prop="empid" label="工号" min-width="25" align="left"></el-table-column>
              <el-table-column prop="pnumber" label="手机号" min-width="40" align="left"></el-table-column>
            </el-table>
            <div class="load" v-if="loadp == 1">
              正在加载更多员工
            </div>
            <div class="load" v-if="loadp == 2">
              已加载全部员工
            </div>
          </div>
        </div>
      </div>
      <div class="btns">
        <div v-if="selectlist.length != 0">
          已选择<span>{{selectlist.length}}</span>人
        </div>
        <button @click="onshut">取消</button>
        <button class="subbtn" @click="onsub">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    created() {
      // 初始化部门数据
      this.loadTree();
      //初始化数据
      this.loadData();
      // 判断页面跳转来源:1 合同添加签署员工 2 签署文件添加员工
      if(this.type == 1){
        this.selectlist = this.default;
        this.selectjson = JSON.stringify(this.default);
      }else{
        this.loadFilePush();
      }
    },
    data() {
      return {
        label: '',
        children: [],
        orgId:"",
        form: {
          orgId: '',
          ids: '',
          bs: 1,
          type: 1,//2待入职 3 未入职
          name:'',
          pageNum: 1,
          pageSize: 10,
          name: '',
          total: 0,
          state: '',
          startDate: '',
          becomeDate: '',
          positionLevel: '',
          employeeInfo: ''
        },
        name: "",
        load: false,
        loadp:0,
        checkAll:false,
        indeterminate:false,
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        list: [],
        selectlist: [],
        allstatus:[],
        selectjson:"",
        parentList: []
      }
    },
    props: {
      //员工名字
      parentListDefault: {
        type: Array,
        default () {
          return [];
        }
      },
      width: {
        default: "890px"
      },
      height: {
        default: "625px"
      },
      type: {
        default: 2
      },
      id: {
        default: "",
      },
      //员工id
      default: {
        type: Array,
        default () {
          return [];
        }
      },

    },
    mounted() {
      this.$refs.tablediv.addEventListener('scroll', this.handleScroll);
      this.selectlist = this.default
      this.parentList = this.parentListDefault
      this.selectjson = JSON.stringify(this.default);
    },
    // updated() {
    //   this.$nextTick(() => {
    //     this.selecked();
    //   })
    // },
    methods: {
      // 查询已经添加的签署文件员工列表
      loadFilePush(){
        //请求参数
        const params ={templateId:this.id};
        //查询列表的方法
        return this.$axios.get('fileSign/queryEmployFilePushAll', { params }).then(res => {
          //数据初始化
          if(res.data.data == null){
            this.selectlist = [];
          }else{
            this.selectlist = res.data.data;
          }
        }).catch(err => {
          //处理错误
          console.error(err);
        })
      },
      // 获取整个部门的员工列表
      getAll() {
        this.form.orgId = this.orgId;
        this.form.pageNum = 1;
        this.loadData();
				this.$refs.trees.setCurrentNode([]);
      },
      // 查询员工列表
      loadData() {
        //封装请求参数
        this.form.pageNum = 1;
        const params = this.form;
        //查询列表的方法
        return this.$axios.get('employee/findEmployeeForSign', {params}).then(res => {
          //数据初始化
          this.list = res.data.data.list;
          //总条数
          this.form.total = res.data.data.total;
          this.selecked();
        }).catch(err => {
          //处理错误
          console.error(err);
        })

      },
      shut() {
        this.$parent.maskshow = false;
      },
      // 弹框取消事件
      onshut() {
        if(this.type == 1){
          this.$emit('shut',JSON.parse(this.selectjson));
        }else{
          this.$emit('shut');
        }

        this.$parent.maskshow = false;
      },
      hideindu(e) {
        e.stopPropagation();
      },
      // 确定按钮提交事件
      onsub() {
        let ids = '';
        // 封装勾选的员工id
        for(var i =0;i<this.selectlist.length;i++){
          if(i!=this.selectlist.length-1){
            ids += this.selectlist[i]+',';
          }else{
            ids += this.selectlist[i];
          }
        }
        let name = '';
        // 封装勾选的员工id
        for(var i =0;i<this.parentList.length;i++){
          if(i!=this.parentList.length-1){
            name += this.parentList[i]+',';
          }else{
            name += this.parentList[i];
          }
        }
        if(ids == ''){
          this.$message.error("请选择需要添加的员工！");
        }else{
          // 1：返回拼接的员工id到合同添加员工 2：请求添加签署文件员工的接口
          if(this.type == 1){
            this.$emit('sub',this.selectlist,this.parentList);
            this.$parent.maskshow = false;
          }else{
            this.$axios.post('fileSign/addEmployFilePush?&templateId='+this.id+"&employIds="+ids).then(res => {
              if (res.data.status === 1) {
                this.$emit('sub',this.id);
                this.$parent.maskshow = false;
              } else {
                this.$message.error(res.data.message);
              }
            }).catch(err => {
              console.log(err)
            })
          }
        }
      },
      // 点击单个
      select(selection, row) {
        var key = this.selectlist.indexOf(row.employId);
        var keys = this.parentList.indexOf(row.name);
        if (keys == -1) {
          this.parentList.push(row.name)
        } else {
          this.parentList.splice(keys, 1)
        }
        if(key == -1) {
          this.selectlist.push(row.employId); // 进行动态的操作
        } else {
          this.selectlist.splice(key, 1);
        }
      },
      //全选
      selectAll(selection) {
        if(selection.length == 0) {
          this.list.forEach((val) => {
            var key = this.selectlist.indexOf(val.employId);
            var keys = this.parentList.indexOf(val.name);

            if(key != -1) {
              this.selectlist.splice(key, 1);
            }

            if (keys != -1) {
              this.parentList.splice(keys, 1);
            }
          })
        } else {
          selection.forEach((val) => {
            var key = this.selectlist.indexOf(val.employId);
            var keys = this.parentList.indexOf(val.name);
            if (keys == -1) {
              this.parentList.push(val.name); // 进行动态的操作
            }
            if(key == -1) {
              this.selectlist.push(val.employId); // 进行动态的操作
            }
          })
        }

      },
      // //全选当前部门员工
      // oncheckAll(){
      //   //封装请求参数
      //   const params = this.form;
      //   //查询列表的方法
      //   return this.$axios.get('employee/findEmployeeByOrgId', {params}).then(res => {
      //     //数据初始化
      //     var sj = res.data.data;
      //     if(this.checkAll){
      //       sj.forEach((val) => {
      //         var key = this.selectlist.indexOf(val);
      //         if(key == -1) {
      //           this.selectlist.push(val);
      //         }
      //       })
      //       this.checkAll = true;
      //     }else{
      //       sj.forEach((val) => {
      //         var key = this.selectlist.indexOf(val);
      //         if(key != -1) {
      //           this.selectlist.splice(key, 1);
      //         }
      //       })
      //       this.$refs.table.clearSelection();
      //       this.checkAll = false;
      //     }
      //   }).catch(err => {
      //     //处理错误
      //     console.error(err);
      //   })
      // },
      //搜索
      onsearch() {
        console.dir(this.name);
      },
      //已选择的值发生变化改变表格选中状态
      selecked() {
        this.$nextTick(() =>{
          if(this.selectlist.length != 0) {
            this.selectlist.forEach(item =>{
              this.list.forEach((val) => {
                if(item == val.employId) {
                  this.$refs.table.toggleRowSelection(val, true);
                }
              })
            })
          }else{
            this.$refs.table.clearSelection();
          }
        })
      },
      //懒加载
      handleScroll() {
        if(!this.load) {
          var tablediv = this.$refs.tablediv;
          if(tablediv.scrollTop + tablediv.clientHeight+1 >= tablediv.scrollHeight) {
            var top = tablediv.scrollTop;
            this.load = true;
            this.loadp = 1;
            this.load =
              this.form.pageNum++;
            const params = this.form;
            //查询列表的方法
            var scrollTop = tablediv.scrollTop;
            this.$axios.get('employee/findEmployeeForSign', {params}).then(res => {
              //this.list = this.list.concat();
              this.$refs.tablediv.scrollTop = scrollTop;
              if(res.data.data.list.length != 0){
                res.data.data.list.forEach((val) => {
                  this.list.push(val);
                  this.load = false;
                  this.loadp = 0;
                })
                this.selecked()
              }else{
                this.load = true;
                this.loadp = 2;
              }
            }).catch(err => {
              //处理错误
              console.error(err);
            })
          }
        }
      },
      //切换部门
      filterNode(data) {
        this.form.pageNum = 1
        this.form.orgId = data.id
        this.loadData()
      },
      loadTree() {
        //封装请求参数
        const params = {orgName: ''}
        //查询列表的方法
        return this.$axios.get('org/tree', {params}).then(res => {
          //数据初始化
          this.label = res.data.data[0].label
          this.orgId = res.data.data[0].id
          this.form.orgId = this.orgId
          this.children = res.data.data[0].children
        }).catch(err => {
          //处理错误
          console.error(err)
        })
      },
    }
  }
</script>

<style scoped lang="less">
  #mask {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .messagebox {
    background-color: #fff;
    box-sizing: border-box;
    max-height: 80%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    .title {
      width: 100%;
      min-height: 66px;
      border-bottom: 1px solid #e9eff4;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding: 0 25px;
      align-items: center;
      h4 {
        font-size: 18px;
        font-weight: bold;
      }
      div {
        width: 12px;
        height: 12px;
        background-image: url(../../assets/img/cha.png);
        background-position: left top;
        background-repeat: no-repeat;
        background-size: 12px;
        cursor: pointer;
      }
      div:hover {
        background-image: url(../../assets/img/cha_check.png);
      }
    }
    .content {
      width: 100%;
      height: 100%;
      overflow: auto;
      display: flex;
      .tree {
        width: 300px;
        height: 100%;
        border-right: 1px solid #e9eff4;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        margin-left: 23px;
        .c_name:hover{
          background-color: #f2f5f8;
        }
        .c_checked{
          background-color: #f2f5f8;
          font-weight: bold;
        }
        .c_checked:after {
          content: "";
          display: block;
          width: 4px;
          height: 42px;
          background-color: #6669e3;
          position: absolute;
          right: 0;
          top: 0;
        }
        .c_name {
          width: 100%;
          height: 42px;
          line-height: 42px;
          // background-color: #f2f5f8;
          font-size: 14px;
          display: flex;
          position: relative;
          padding-left: 28px;
          box-sizing: border-box;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .c_tree {
          width: 100%;
          box-sizing: border-box;
        }
      }
      .ctable {
        width: 590px;
        /*overflow: auto;*/
        padding: 0 17px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        .name {
          margin-top: 20px;
          font-size: 14px;
          font-weight: bold;
          margin-right: 14px;
          min-height: 21px;
        }
        .search {
          display: flex;
          align-items: center;
          font-size: 14px;
          padding: 19px 0;
          min-height: 34px;
          span {
            margin-right: 15px;
          }
          button {
            margin-left: 17px;
          }
        }
        .checkedall {
          padding-bottom: 12px;
          padding-left: 14px;
        }
        .table {
          width: 100%;
          height: 100%;
          overflow: auto;
          .load {
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
          }
        }
      }
    }
    .btns {
      width: 100%;
      min-height: 62px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background-color: #f2f5f8;
      padding: 0 25px;
      box-sizing: border-box;
      div {
        font-size: 14px;
        font-weight: bold;
        span {
          color: #6669e3;
        }
      }
      button {
        min-width: 82px;
        height: 32px;
        color: #6669e3;
        border: 1px solid #6669e3;
        margin-left: 15px;
        border-radius: 6px;
        background-color: #f2f5f8;
        font-size: 14px;
        cursor: pointer;
        padding: 0 20px;
      }
      button:first-child {
        margin-left: 0;
      }
      .subbtn {
        background-color: #6669e3;
        color: #FFFFFF;
      }
    }
    .block {
      padding: 4px 5px;
      border-radius: 4px;
      font-size: 12px;
      color: #fff;
      text-align: center;
      line-height: 20px;
    }
    .redbg {
      background-color: #ff6752;
    }
    .greenbg {
      background-color: #3bc798;
    }
  }
</style>
